var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLobster(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe646f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb2b3a"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientTransform: "matrix(.707 -.707 .707 .707 -462.783 -580.932)",
    gradientUnits: "userSpaceOnUse",
    x1: -209.165,
    x2: -94.868,
    xlinkHref: "#lg1",
    y1: 936.322,
    y2: 1019.037
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe860a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6914,
    stopColor: "#fc482b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb2b3a"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientTransform: "matrix(.933 .359 -.359 .933 -313.715 240.426)",
    gradientUnits: "userSpaceOnUse",
    x1: 315.26,
    x2: 344.597,
    xlinkHref: "#lg2",
    y1: -222.116,
    y2: -200.885
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientTransform: "matrix(.933 .359 -.359 .933 -313.715 240.426)",
    gradientUnits: "userSpaceOnUse",
    x1: 319.906,
    x2: 362.095,
    xlinkHref: "#lg2",
    y1: -290.821,
    y2: -239.592
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientTransform: "matrix(.933 .359 -.359 .933 -313.715 240.426)",
    gradientUnits: "userSpaceOnUse",
    x1: 297.692,
    x2: 366.4,
    xlinkHref: "#lg2",
    y1: -314.206,
    y2: -264.483
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientTransform: "matrix(.804 .594 -.594 .804 81.223 470.832)",
    gradientUnits: "userSpaceOnUse",
    x1: -38.868,
    x2: -18.376,
    xlinkHref: "#lg1",
    y1: -166.218,
    y2: -137.289
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientTransform: "matrix(.804 .594 -.594 .804 81.223 470.832)",
    gradientUnits: "userSpaceOnUse",
    x1: -0.916,
    x2: 18.675,
    xlinkHref: "#lg1",
    y1: -114.845,
    y2: -112.606
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientTransform: "matrix(-.707 -.707 -.707 .707 -1424.118 -580.932)",
    gradientUnits: "userSpaceOnUse",
    x1: -1904.03,
    x2: -1789.733,
    xlinkHref: "#lg1",
    y1: -758.543,
    y2: -675.828
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientTransform: "matrix(-.933 .359 .359 .933 -1573.186 240.426)",
    gradientUnits: "userSpaceOnUse",
    x1: -1921.866,
    x2: -1892.528,
    xlinkHref: "#lg2",
    y1: 638.351,
    y2: 659.583
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientTransform: "matrix(-.933 .359 .359 .933 -1573.186 240.426)",
    gradientUnits: "userSpaceOnUse",
    x1: -1917.219,
    x2: -1875.03,
    xlinkHref: "#lg2",
    y1: 569.646,
    y2: 620.876
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientTransform: "matrix(-.933 .359 .359 .933 -1573.186 240.426)",
    gradientUnits: "userSpaceOnUse",
    x1: -1939.433,
    x2: -1870.725,
    xlinkHref: "#lg2",
    y1: 546.262,
    y2: 595.985
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientTransform: "matrix(-.804 .594 .594 .804 -1968.124 470.832)",
    gradientUnits: "userSpaceOnUse",
    x1: -1966.617,
    x2: -1946.126,
    xlinkHref: "#lg1",
    y1: 1258.183,
    y2: 1287.112
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientTransform: "matrix(-.804 .594 .594 .804 -1968.124 470.832)",
    gradientUnits: "userSpaceOnUse",
    x1: -1928.666,
    x2: -1909.074,
    xlinkHref: "#lg1",
    y1: 1309.555,
    y2: 1311.794
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 219.242,
    x2: 306.912,
    xlinkHref: "#lg2",
    y1: 435.486,
    y2: 523.156
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.845,
    x2: 267.494,
    xlinkHref: "#lg3",
    y1: 472.201,
    y2: 452.72
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe9738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5852,
    stopColor: "#fc5a39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb2b3a"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientTransform: "matrix(0 1 1 0 -1316.007 1167.305)",
    gradientUnits: "userSpaceOnUse",
    x1: -724.268,
    x2: -709.324,
    xlinkHref: "#lg4",
    y1: 1563.3,
    y2: 1602.043
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 269.51,
    x2: 269.51,
    xlinkHref: "#lg3",
    y1: 465.659,
    y2: 408.059
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 247.42,
    x2: 288.733,
    xlinkHref: "#lg4",
    y1: 363.614,
    y2: 446.24
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 257.971,
    x2: 257.971,
    xlinkHref: "#lg3",
    y1: 410.911,
    y2: 349.413
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 247.586,
    x2: 280.837,
    xlinkHref: "#lg2",
    y1: 297.998,
    y2: 386.67
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 257.891,
    x2: 257.891,
    xlinkHref: "#lg3",
    y1: 364.56,
    y2: 286.611
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 240.179,
    x2: 315.751,
    xlinkHref: "#lg4",
    y1: 220.656,
    y2: 349.633
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.317,
    x2: 258.317,
    xlinkHref: "#lg3",
    y1: 296.041,
    y2: 194.107
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 281.463,
    x2: 297.585,
    xlinkHref: "#lg2",
    y1: 33.842,
    y2: 55.506
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientTransform: "matrix(-1 0 0 1 -1542.4 0)",
    gradientUnits: "userSpaceOnUse",
    x1: -1770.937,
    x2: -1754.815,
    xlinkHref: "#lg2",
    y1: 33.842,
    y2: 55.506
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 210.297,
    x2: 337.688,
    xlinkHref: "#lg2",
    y1: 119.702,
    y2: 247.093
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 190.719,
    x2: 206.897,
    xlinkHref: "#lg5",
    y1: 101.713,
    y2: 117.891
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 290.302,
    x2: 306.48,
    xlinkHref: "#lg5",
    y1: 101.713,
    y2: 117.891
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m201.252 272.52c-2.48 1.624-5.44 2.563-8.624 2.563l-62.437.006c-46.187-.006-83.763-37.582-83.769-83.769v-16.864c.006-8.739 7.089-15.822 15.822-15.822 8.745 0 15.828 7.083 15.822 15.822v16.864c0 28.741 23.384 52.126 52.126 52.126h38.573c2.071 2.941 4.481 5.798 7.249 8.566 7.927 7.927 16.391 14.767 25.238 20.508z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m102.648 166.317c-5.197 13.51-24.52 18.65-43.161 11.481s-29.539-23.934-24.343-37.445 72.701 12.454 67.504 25.964z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 95.163,
    cy: 101.516,
    fill: "url(#SVGID_3_)",
    r: 68.179
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.75 165.174c4.01 1.539 8.398 1.85 12.608 1.001 49.748-10.037 19.663-39.485 36.172-56.657 17.222-17.914-3.245-16.746-2.379-44.18.491-15.566 16.235-27.551 29.765-35.007 6.525-3.596 6.747-12.898.465-16.905-5.556-3.545-11.621-6.504-18.144-8.762-42.859-14.839-90.325 6.871-107.181 48.976-17.739 44.312 4.226 94.43 48.631 111.51z",
    fill: "url(#SVGID_4_)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m211.188 357.6-26.164-12.891c-25.781-12.71-57.087-2.075-69.797 23.706l-7.452 15.121c-3.871 7.841-13.356 11.062-21.189 7.196-.866-.426-1.67-.919-2.419-1.473-6.042-4.465-8.215-12.736-4.782-19.709l7.457-15.128c20.425-41.426 70.744-58.517 112.168-38.104l19.232 9.478c-3.618 10.48-5.966 21.143-7.054 31.804z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159.416 441.769c-1.374 8.629-9.481 14.52-18.111 13.146-2.589-.406-4.934-1.431-6.912-2.892-4.595-3.395-7.19-9.179-6.228-15.213l2.638-16.654c3.502-22.097 15.411-41.501 33.514-54.652 14.164-10.285 30.787-15.774 47.936-15.996-1.72 10.588-2.192 21.222-1.469 31.715-9.976.509-19.605 3.881-27.876 9.887-11.268 8.176-18.666 20.256-20.855 34.005z",
    fill: "url(#SVGID_6_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m308.748 272.52c2.48 1.624 5.44 2.563 8.624 2.563l62.437.006c46.187-.006 83.763-37.582 83.769-83.769v-16.864c-.006-8.739-7.089-15.822-15.822-15.822-8.745 0-15.828 7.083-15.822 15.822v16.864c0 28.741-23.384 52.126-52.126 52.126h-38.573c-2.071 2.941-4.481 5.798-7.249 8.566-7.927 7.927-16.391 14.767-25.238 20.508z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m407.352 166.317c5.197 13.51 24.52 18.65 43.161 11.481 18.641-7.17 29.539-23.934 24.343-37.445s-72.701 12.454-67.504 25.964z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 414.837,
    cy: 101.516,
    fill: "url(#SVGID_9_)",
    r: 68.179
  }), /*#__PURE__*/React.createElement("path", {
    d: "m439.25 165.174c-4.01 1.539-8.398 1.85-12.608 1.001-49.748-10.037-19.663-39.485-36.172-56.657-17.222-17.914 3.245-16.746 2.379-44.18-.491-15.566-16.235-27.551-29.765-35.007-6.525-3.596-6.747-12.898-.465-16.905 5.556-3.545 11.621-6.504 18.144-8.762 42.858-14.839 90.324 6.871 107.18 48.977 17.739 44.312-4.226 94.43-48.631 111.51-.02.007-.041.015-.062.023z",
    fill: "url(#SVGID_10_)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m298.812 357.6 26.164-12.891c25.781-12.71 57.087-2.075 69.797 23.706l7.452 15.121c3.871 7.841 13.356 11.062 21.189 7.196.866-.426 1.67-.919 2.419-1.473 6.042-4.465 8.215-12.736 4.782-19.709l-7.457-15.128c-20.425-41.426-70.744-58.517-112.168-38.104l-19.232 9.478c3.618 10.48 5.966 21.143 7.054 31.804z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350.584 441.769c1.374 8.629 9.481 14.52 18.111 13.146 2.589-.406 4.934-1.431 6.912-2.892 4.595-3.395 7.19-9.179 6.228-15.213l-2.638-16.654c-3.502-22.097-15.411-41.501-33.514-54.652-14.164-10.285-30.787-15.774-47.936-15.996 1.72 10.588 2.192 21.222 1.469 31.715 9.976.509 19.605 3.881 27.876 9.887 11.268 8.176 18.665 20.256 20.855 34.005z",
    fill: "url(#SVGID_12_)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m255 403.461c-22.845 0-65.454 31.971-65.454 75.344 0 10.555 3.877 18.467 9.743 24.397 10.211 10.322 23.541 8.676 32.876-3.488 7.834-10.208 16.512-16.133 22.835-16.133s15.001 5.925 22.835 16.133c9.335 12.165 22.664 13.81 32.876 3.488 5.866-5.93 9.743-13.841 9.743-24.397 0-43.373-42.609-75.344-65.454-75.344z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m277.835 499.714c9.335 12.165 22.664 13.81 32.876 3.488 5.866-5.93 9.743-13.842 9.743-24.397 0-43.373-42.609-75.344-65.454-75.344v80.12c6.323 0 15.001 5.924 22.835 16.133z",
    fill: "url(#SVGID_14_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m255 386.835c-8.3 0-23.78 31.987-23.78 75.383s23.78 42.132 23.78 42.132 23.78 1.264 23.78-42.132-15.48-75.383-23.78-75.383z",
    fill: "url(#SVGID_15_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m320.456 478.809c0 10.55-3.879 18.46-9.744 24.395-1.663 1.683-3.416 3.053-5.22 4.101l-86.928-86.928c7.184-6.187 14.883-10.882 22.047-13.734 4.776-12.434 10.409-19.81 14.389-19.81s9.613 7.376 14.389 19.81c22.823 9.098 51.067 36.849 51.067 72.166z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.95 377.185-8.509-31.26c-15.073 12.381-34.698 19.872-56.164 19.872-21.721 0-41.552-7.674-56.694-20.319l-8.524 31.315c-3.374 12.396 1.109 25.602 11.707 33.628 14.69 11.125 33.285 17.771 53.511 17.771 19.609 0 37.684-6.248 52.154-16.766 11.065-8.043 15.987-21.501 12.519-34.241z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m307.427 411.429c-12.384 9.008-27.408 14.873-43.782 16.374l-68.751-68.761 3.688-13.563c15.145 12.646 34.975 20.314 56.689 20.314 21.473 0 41.091-7.487 56.165-19.871l8.514 31.267c3.468 12.737-1.459 26.199-12.523 34.24z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m333.139 313.506-10.237-40c-18.133 15.842-41.743 25.428-67.569 25.428-26.131 0-49.989-9.82-68.206-26l-10.255 40.07c-4.059 15.861 1.334 32.759 14.085 43.029 17.673 14.235 40.043 22.74 64.376 22.74 23.59 0 45.335-7.995 62.744-21.454 13.312-10.292 19.234-27.512 15.062-43.813z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m318.078 357.319c-15.225 11.769-33.766 19.367-53.959 21.08l-82.797-82.797 5.804-22.672c18.218 16.183 42.079 26.007 68.207 26.007 25.826 0 49.434-9.593 67.572-25.433l10.238 40.003c4.17 16.303-1.754 33.524-15.065 43.812z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m345.947 245.24-11.915-46.557c-21.106 18.439-48.586 29.596-78.644 29.596-30.415 0-58.183-11.429-79.386-30.262l-11.936 46.638c-4.725 18.461 1.553 38.129 16.393 50.083 20.57 16.568 46.607 26.467 74.929 26.467 27.457 0 52.767-9.305 73.029-24.97 15.493-11.978 22.386-32.022 17.53-50.995z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m345.947 245.24-11.915-46.557c-21.106 18.439-48.586 29.596-78.644 29.596-30.415 0-58.183-11.429-79.386-30.262l-6.849 26.762 96.021 96.021c23.672-1.928 45.413-10.78 63.243-24.566 15.494-11.977 22.386-32.021 17.53-50.994z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m261.58 61.305c0-23.682 19.267-42.949 42.949-42.949 6.297 0 11.402 5.105 11.402 11.402s-5.105 11.402-11.402 11.402c-11.108 0-20.144 9.036-20.144 20.144h-22.805z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248.42 61.305c0-23.682-19.267-42.949-42.949-42.949-6.297 0-11.402 5.105-11.402 11.402s5.105 11.402 11.402 11.402c11.108 0 20.144 9.036 20.144 20.144h22.805z",
    fill: "url(#SVGID_24_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m255 53.996c-56.506 0-100.763 54.773-100.763 129.082s100.763 72.143 100.763 72.143 100.763 2.164 100.763-72.144-44.257-129.081-100.763-129.081z",
    fill: "url(#SVGID_25_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 205.209,
    cy: 116.203,
    fill: "url(#SVGID_26_)",
    r: 20.056
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 304.791,
    cy: 116.203,
    fill: "url(#SVGID_27_)",
    r: 20.056
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLobster);
export default __webpack_public_path__ + "static/media/icon-lobster.d6f3a4f8339e4fe964bd4623905fe367.svg";
export { ForwardRef as ReactComponent };